var map = {
	"./en-gb.json": [
		87794,
		"src_assets_i18n_en-gb_json"
	],
	"./en-us.json": [
		2848,
		"src_assets_i18n_en-us_json"
	],
	"./es-mx.json": [
		12922,
		"src_assets_i18n_es-mx_json"
	],
	"./pt-br.json": [
		43888,
		"src_assets_i18n_pt-br_json"
	],
	"./pt.json": [
		5733,
		"src_assets_i18n_pt_json"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 16297;
module.exports = webpackAsyncContext;